"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const WifiOff_1 = __importDefault(require("@mui/icons-material/WifiOff"));
const Chat_1 = __importDefault(require("@mui/icons-material/Chat"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const SocketContext_1 = require("../Chat/SocketContext");
const ClientChat_1 = __importDefault(require("../Chat/ClientChat"));
const ChatPage = styled_components_1.default.div `
  background-color: #f7f8f9;
  overflow-y: scroll;
  padding-bottom: 0px;
  margin: 0 auto;

  height: calc(100% - 60px);

  margin-right: 0;
  transition: margin-right 0.2s;

  /* &.keyboard-open{
         border-right: solid grey 1px;
         margin-right: 20px;
         box-shadow: 1px 0px 5px grey;
    } */

  .no-internet-banner {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: ${props => props.theme.palette.mainAppColor.light};
    display: flex;
    justify-content: center;
    padding: 5px;

    svg {
      margin-right: 5px;
    }
  }
`;
const EnableNotificationsToUseChat = styled_components_1.default.div `
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100% - 60px);

  .chat-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 16px;
  }

  .center-text {
    text-align: center;
  }

  .ios-info-section {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .info-icon {
      margin-right: 6px;
      height: 20px;
      width: 20px;
    }
  }
`;
const Chat = ({ userData, navigations, currentLocale, baseUrl, pushNotificationsEnabled, appData }) => {
    var _a;
    const [chatIntroWasShown, setChatIntroWasShown] = (0, react_1.useState)(localStorage.getItem('chatIntroWasShown'));
    const [isOnline, setIsOnline] = (0, react_1.useState)(window.navigator.onLine);
    const isLoggedIn = userData.loginProviders.length > 0 && userData.loginProviders[0].loggedIn;
    const isTuiBrand = helpers_1.Helpers.isTuiBrand(appData.brandSlug);
    (0, react_1.useEffect)(() => {
        if (chatIntroWasShown !== 'true') {
            const notificationDenied = 'Notification' in window && Notification.permission === 'denied';
            const onAccept = () => {
                localStorage.setItem('chatIntroWasShown', 'true');
                setChatIntroWasShown('true');
            };
            const showChatIntroModal = () => {
                setTimeout(() => {
                    helpers_1.Helpers.openModal(modalEnums_1.default.CHAT_INTRO, {
                        onAccept,
                        disableCloseOnClickOutsideModal: true,
                        disableCloseOnResize: true,
                    });
                }, isTuiBrand && !notificationDenied ? 0 : 400);
            };
            if (isLoggedIn && !isTuiBrand) {
                showChatIntroModal();
            }
            if (isLoggedIn && isTuiBrand) {
                if (!notificationDenied) {
                    helpers_1.Helpers.openModal(modalEnums_1.default.TUI_CHAT_MODAL, {
                        showChatIntroModal,
                        disableCloseOnClickOutsideModal: true,
                        disableCloseOnResize: true,
                    });
                }
                else {
                    showChatIntroModal();
                }
            }
        }
        const onGoingOnline = () => {
            setIsOnline(true);
        };
        const onGoingOffline = () => {
            setIsOnline(false);
        };
        const handleChatScroll = evt => {
            evt.stopPropagation();
        };
        window.addEventListener('online', onGoingOnline);
        window.addEventListener('offline', onGoingOffline);
        const webapp = document.querySelector('#webapp');
        const chatPage = document.querySelector('.chat-page');
        if (webapp) {
            webapp.style.height = '100%';
        }
        if (chatPage) {
            chatPage.addEventListener('scroll', handleChatScroll);
        }
        return () => {
            window.removeEventListener('online', onGoingOnline);
            window.removeEventListener('offline', onGoingOffline);
            if (webapp) {
                webapp.style.height = 'auto';
            }
            if (chatPage) {
                chatPage.removeEventListener('scroll', handleChatScroll);
            }
        };
    }, []);
    if (!isLoggedIn) {
        const redirectUrl = encodeURIComponent(`${window.location.origin}${baseUrl}/chat${window.location.search}`);
        window.location.replace(`${userData.loginProviders[0].loginUrl}&redirect_back_to=${redirectUrl}`);
        return react_1.default.createElement(react_1.Fragment, null);
    }
    const chatItem = navigations.homePage.find(navigation => navigation.type === 'chat');
    if (isTuiBrand && !pushNotificationsEnabled && !helpers_1.Helpers.isMobile.iOS()) {
        return (react_1.default.createElement(EnableNotificationsToUseChat, null,
            react_1.default.createElement("div", { className: "icon-wrapper" }, chatItem && chatItem.icon ? (react_1.default.createElement("img", { className: "chat-icon", src: chatItem.icon, alt: "chat-icon" })) : (react_1.default.createElement(Chat_1.default, { className: "chat-icon" }))),
            react_1.default.createElement(material_1.Typography, { variant: "body1", className: "center-text" },
                i18n_js_1.default.t('chat_enable_notifications_to_use_chat'),
                react_1.default.createElement("br", null),
                react_1.default.createElement("a", { href: "https://help.hotel-mssngr.com/en/articles/8965701-how-to-activate-push-notifications", target: "_blank", rel: "noreferrer", className: "notification-info-link" }, i18n_js_1.default.t('learn_more_about_notifications_how_to_enable_notifications')))));
    }
    if (chatIntroWasShown !== 'true') {
        return react_1.default.createElement(react_1.Fragment, null);
    }
    const { token, topic } = userData.chat;
    const chatTile = navigations.homePage.find(tile => tile.type === 'chat');
    const url = chatTile ? (_a = chatTile === null || chatTile === void 0 ? void 0 : chatTile.payload) === null || _a === void 0 ? void 0 : _a.url : '';
    const accountId = topic.split(':')[1];
    const socketOptions = { params: { token, locale: currentLocale } };
    return (react_1.default.createElement(SocketContext_1.SocketProvider, { url: url, options: socketOptions },
        react_1.default.createElement(ChatPage, { className: "chat-page" },
            !isOnline && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement("div", { className: "no-internet-banner" },
                    react_1.default.createElement(WifiOff_1.default, null),
                    react_1.default.createElement(material_1.Typography, { variant: "body2" }, i18n_js_1.default.t('application_offline_message'))))),
            react_1.default.createElement(ClientChat_1.default, { accountId: accountId, isOnline: isOnline }))));
};
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
    navigations: store.getValue('navigations'),
    userData: store.getValue('userData'),
    currentLocale: store.getValue('currentLocale'),
    pushNotificationsEnabled: store.getValue('pushNotificationsEnabled'),
    appData: store.getValue('appData'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Chat);
